// extracted by mini-css-extract-plugin
export default {"underBanner":"UnderBanner_underBanner__BH6-C","col":"UnderBanner_col__51GuU"};